// Studio team Inc 2 — live agenda for the production team. TanStack Query for the
// list + a Supabase Realtime subscription (postgres_changes, filtered by room_id)
// that invalidates the query so inserts/updates/deletes/reorders propagate to the
// whole panel. Realtime enforces room_agenda_team_all per subscriber, so only
// producers receive events. Mirrors the marketing CorrectionsLive pattern.

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { listAgenda } from './roomAgendaActions';

import { supabase } from '@/lib/supabase';

export function useRoomAgenda(roomId: string) {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ['room-agenda', roomId],
    enabled: Boolean(roomId),
    queryFn: () => listAgenda(roomId),
  });

  useEffect(() => {
    if (!roomId) return;
    const channel = supabase
      .channel(`room-agenda:${roomId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'room_agenda_items',
          filter: `room_id=eq.${roomId}`,
        },
        () => {
          void qc.invalidateQueries({ queryKey: ['room-agenda', roomId] });
        },
      )
      .subscribe();
    return () => {
      void supabase.removeChannel(channel);
    };
  }, [roomId, qc]);

  return query;
}
